// auto-generated by Typewriter template _models.tst from PortCall.Models\Billing\QuickBooks\QuickBooksBillingSystemTracking.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// QuickBooksBillingSystemTrackingData is the class that QuickBooksBillingSystemTracking serializes to/from
export interface QuickBooksBillingSystemTrackingData {
	
	
    InvoiceAccount : string | null;
    Terms : string | null;
}

// QuickBooksBillingSystemTrackingOptions is the class which may be passed to the QuickBooksBillingSystemTracking constructor to define optional initial data values
export interface QuickBooksBillingSystemTrackingOptions {
	
	
    InvoiceAccount? : string | null;
    Terms? : string | null;
}

export class QuickBooksBillingSystemTracking {
	
	
    public InvoiceAccount : DataSignal<string | null>;
    public Terms : DataSignal<string | null>;

    constructor();
    constructor(data : QuickBooksBillingSystemTrackingOptions);
    constructor(data: QuickBooksBillingSystemTrackingOptions | null = null) {
	    
	    
        this.InvoiceAccount = jsonableObservable(S.value<string | null>(data && data.InvoiceAccount !== undefined ? data.InvoiceAccount : null));
        this.Terms = jsonableObservable(S.value<string | null>(data && data.Terms !== undefined ? data.Terms : null));
    }

    static key(obj : QuickBooksBillingSystemTracking) {
        return ;
    }
    
    static dataKey(obj : QuickBooksBillingSystemTrackingOptions) {
        return ;
    }

    static update(obj : QuickBooksBillingSystemTracking, data : QuickBooksBillingSystemTrackingOptions) {
        S.freeze(() => {
	        
	        
            if (data.InvoiceAccount !== undefined) obj.InvoiceAccount(data.InvoiceAccount);
            if (data.Terms !== undefined) obj.Terms(data.Terms);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/QuickBooksBillingSystemTracking.ts